import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import {
  Divider,
  Checkbox,
  Card,
  CardContent,
  CardHeader,
  Button,
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  LinearProgress,
  Snackbar,
  Typography,
  Grid,
  Slide,
  Input,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  FormLabel,
  TextField,
  Box
} from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { getUser, setSepetAdet, getSepetAdet } from 'src/utils/Common';
import axios from 'src/utils/axios';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { CustomTableCell } from 'src/components/CustomTableCell';
import MuiAlert from '@material-ui/lab/Alert';
import LockIcon from '@material-ui/icons/Lock';
import DoneIcon from '@material-ui/icons/Done';
import BallotIcon from '@material-ui/icons/Ballot';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {},
  divider: {
    backgroundColor: '#FF9800'
  },
  table: {
    minWidth: 600
  },
  button: {
    margin: theme.spacing(0.2)
  },
  highlightRow: {
    backgroundColor: '#f5c6cb'
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function MaterialOrder(SepetData, ...rest) {
  const [selected, setSelected] = React.useState([]);
  const classes = useStyles();
  const [previous, setPrevious] = React.useState({});
  const [SiparisData, setSiparisData] = useState([]);
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(false);
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [open, setOpen] = React.useState(false);
  const [dialogTitle, setDialogTitle] = React.useState('');
  const [ImageUrlMuadil, setImageUrlMuadil] = useState(null);
  const [DeleteId, setDeleteId] = useState(0);
  const [SecKontrol, setSecKontrol] = useState(0);
  const [SecKontrolYazi, setSecKontrolYazi] = useState('TümünüSeç');
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [limiteTakilanlar, setLimiteTakilanlar] = useState([]);
  const [openApproveDialog, setApproveDialog] = useState(false);
  const [approveReason, setApproveReason] = useState('');
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [openOrderTypeDialog, setOpenOrderTypeDialog] = useState(false);
  const [orderType, setOrderType] = useState('');
  const [orderReason, setOrderReason] = useState('');
  const [buttonDisabled, setButtonDisabled] = useState(false);
  var Deger = 0;

  const handleOrderTypeChange = event => {
    setOrderType(event.target.value);
  };

  const handleOrderReason = event => {
    setOrderReason(event.target.value);
  };

  const handleInputChange = event => {
    setApproveReason(event.target.value);
  };

  const handleCloseApproveDialog = () => {
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const SendData = SiparisData.filter(
      d => parseInt(d.RowSelected) === parseInt(1)
    );

    if (SendData.length === 0) {
      setLoading(false);
      setUyariTip('error');
      setUyariAciklama('Lütfen sipariş vermek istediğiniz satırı seçiniz!...');
      setUyari(true);
      return;
    }
    const SendDataAdetKontrol = SendData.filter(
      d => parseInt(d.Count) === parseInt(0)
    );
    if (SendDataAdetKontrol.length > 0) {
      setLoading(false);
      setUyariTip('error');
      setUyariAciklama(
        'Sipariş vermek istediginiz malzemenin adedi girilmedi. Lütfen kontrol ediniz!...'
      );
      setUyari(true);
      return;
    }
    if (!approveReason) {
      setLoading(false);
      setUyariTip('error');
      setUyariAciklama('Siparişin onaya gönderilme nedeni boş geçilemez!');
      setUyari(true);
      setApproveDialog(false);
      return;
    }

    const data = SendData.filter(
      item => item.KULLANICI !== 'Min Stok Tamamlama'
    ).map(item => ({
      ServiceShopId: SessionUser.ServiceShopId,
      TechnicianId: SessionUser.TechnicianId,
      MaterialCode: item.MALZEME_STOK_NO,
      Count: item.Count,
      UserId: SessionUser.OrganizationUserId,
      Line: getIndex(item.MALZEME_STOK_NO, SendData) + 1,
      Id: item.ID,
      ApproveReason: approveReason
    }));

    axios
      .post('/SetMaterialOrderSendtoApprove', data, config)
      .then(response => {
        setLoading(false);
        let ResponseData = response.data[0];
        setUyariTip(ResponseData.ErrorCode === '1000' ? 'error' : 'success');
        setUyariAciklama(ResponseData.ErrorDescription);
        setUyari(true);
        Sorgula();
      });
    setApproveReason('');
    setApproveDialog(false);
  };

  function subtotal(items) {
    return (
      items
        .filter(d => parseInt(d.RowSelected) === 1)
        // .map(({ BIRIM_FIYAT }) => BIRIM_FIYAT)
        .reduce((sum, i) => sum + i.BIRIM_FIYAT * i.Count, 0)
    );
  }
  function counttotal(items) {
    return items
      .filter(d => parseInt(d.RowSelected) === 1)
      .map(({ Count }) => Count)
      .reduce((sum, i) => sum + parseInt(i), 0);
  }

  const handleClose = () => {
    setOpen(false);
  };

  const isSelected = ID => selected.indexOf(ID) !== -1;
  const onChange = (e, row) => {
    if (!previous[row.ID]) {
      setPrevious(state => ({ ...state, [row.ID]: row }));
    }

    var value = e.target.value;
    const name = e.target.name;

    if (value < 0) {
      value = 0;
    } else if (value > 999) {
      value = 999;
    }

    if (parseInt(e.target.value) > 0) {
      row.MALZEME_KDVLI_FIYAT = row.BIRIM_FIYAT * parseInt(e.target.value);
    }

    const newRows = SiparisData.map(item => {
      if (item.ID === row.ID) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setSiparisData(newRows);
  };
  const handleClick = (event, row, index) => {
    if (parseInt(row.SilinemezMalzeme) === 1) {
      setUyariTip('error');
      setUyariAciklama(
        'Planlama gereği sipariş vermeniz gereken malzemeyi 3 gün geçmesine rağmen vermediğiniz için sipariş vermeniz gerekiyor!...'
      );
      setUyari(true);
      return;
    }

    if (row.RowSelected === 0) {
      row.RowSelected = 1;
    } else {
      row.RowSelected = 0;
    }
    let SiparisDataOld = [...SiparisData];
    setSiparisData(SiparisDataOld);
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  Deger = getSepetAdet();

  useEffect(() => {
    setLimiteTakilanlar([]);
    setSiparisData(SepetData.SepetData);
  }, [SepetData.SepetData]);

  if (SepetData.SepetData.length === 0) {
    return <div></div>;
  }

  const Sorgula = () => {
    setLoading(true);
    axios
      .get(
        `/GetMaterialOrderBasket/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`
      )
      .then(response => {
        setLoading(false);

        if (response.data.length > 0) {
          setSiparisData(response.data);
          setSepetAdet(response.data.length);
        } else {
          setSepetAdet(0);
          setSiparisData([]);
        }
      })
      .catch(error => {
        setSepetAdet(0);
        setSiparisData([]);
        console.log(error);
      });
  };

  const invoiceTotal = subtotal(SiparisData);
  const CountTotal = counttotal(SiparisData);

  function getIndex(param, arr) {
    return arr.findIndex(obj => obj.MALZEME_STOK_NO === param);
  }

  const TumuSec = event => {
    var kontrol = 1;
    if (SecKontrol === 1) {
      kontrol = 1;
      setSecKontrolYazi('TümünüSeç');
    } else {
      kontrol = 1;
      setSecKontrolYazi('TümünüSeç');
    }
    let SiparisDataOld = [...SiparisData];

    SiparisDataOld.filter(x => x.SIP_VERILEBILIR === 1).forEach(e => {
      e.RowSelected = kontrol;
    });

    setSiparisData(SiparisDataOld);
    setSecKontrol(kontrol);
  };

  const OnayaGonder = () => {
    const data = SiparisData.filter(
      item =>
        parseInt(item.RowSelected) === parseInt(1) && item.PLANLAMA_TIPI !== 1
    );

    const checkSiparisData = data.filter(
      x =>
        x.ONAY_DURUMU != null &&
        x.ONAY_DURUMU != undefined &&
        x.ONAY_DURUMU != '' &&
        x.ONAY_DURUMU != '-' &&
        x.ONAY_DURUMU != 'Onaylandi'
    );

    if (checkSiparisData.length > 0) {
      setLoading(false);
      setUyariTip('error');
      setUyariAciklama(
        'Onaya gönderilmiş veya reddedilmiş siparişler hakkında tekrar işlem yapılamaz!'
      );
      setUyari(true);
      setApproveDialog(false);
      return false;
    }

    return true;
  };

  const SipariVer = event => {
    setButtonDisabled(true);

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const SendData = SiparisData.filter(
      d => parseInt(d.RowSelected) === parseInt(1)
    );
    if (!OnayaGonder() && SendData.length > 0) {
      setButtonDisabled(false);
      return;
    }

    if (SendData.length === 0) {
      setLoading(false);
      setUyariTip('error');
      setUyariAciklama('Lütfen sipariş vermek istediğiniz satırı seçiniz!...');
      setButtonDisabled(false);
      setUyari(true);
      return;
    }
    const SendDataAdetKontrol = SendData.filter(
      d => parseInt(d.Count) === parseInt(0)
    );
    if (SendDataAdetKontrol.length > 0) {
      setLoading(false);
      setUyariTip('error');
      setUyariAciklama(
        'Sipariş vermek istediginiz malzemenin adedi girilmedi. Lütfen kontrol ediniz!...'
      );
      setButtonDisabled(false);
      setUyari(true);
      return;
    }
    const data = SendData.map(item => ({
      ServiceShopId: SessionUser.ServiceShopId,
      TechnicianId: SessionUser.TechnicianId,
      MaterialCode: item.MALZEME_STOK_NO,
      Count: item.Count,
      UserId: SessionUser.OrganizationUserId,
      Line: getIndex(item.MALZEME_STOK_NO, SendData) + 1,
      Id: item.ID,
      OrderType: orderType,
      OrderReason: orderReason,
      TopServiceShopName: SessionUser.TopServiceShopName
    }));

    axios
      .post('/SetMaterialOrderSendtoCenter', data, config)
      .then(response => {
        setLoading(false);
        let ResponseData = response.data[0];
        if (
          ResponseData.ErrorCode === '1000' ||
          ResponseData.ErrorCode === '2000'
        ) {
          setUyariTip('error');
        } else {
          setUyariTip('success');
        }
        if (ResponseData.ErrorCode === '2000' && orderType === '') {
          const errorDescription = ResponseData.ErrorDescription.split(
            ' için'
          )[0];
          const regex = /([^,\s]+)(?=,|\s+ile\s+|\s+için|$)/g;
          const matches = errorDescription.match(regex);
          setLimiteTakilanlar(matches);
          setOpenOrderTypeDialog(true);
        } else {
          setUyariAciklama(ResponseData.ErrorDescription);
          setUyari(true);
          Sorgula();

          const errorDescription = ResponseData.ErrorDescription.split(
            ' için'
          )[0];
          const regex = /([^,\s]+)(?=,|\s+ile\s+|\s+için|$)/g;
          const matches = errorDescription.match(regex);
          setLimiteTakilanlar(matches);
          setOrderType('');
          setOrderReason('');
        }
      })
      .catch(err => {
        setButtonDisabled(false);
      })
      .finally(() => {
        setButtonDisabled(false);
      });
  };

  const SetMalzemeSiparisCikarKabul = (row, Id) => {
    setLoading(true);
    axios
      .get(
        `/SetMaterialOrderBasketDelete/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${Id}`
      )
      .then(response => {
        Deger = getSepetAdet();
        setSepetAdet(Deger);
        setLoading(false);
        Sorgula();
        setDialogTitle('');
        setOpen(false);
      })
      .catch(error => {
        console.log(error);
        setOpen(false);
      });
  };

  const SetMalzemeSiparisCikar = row => {
    setDialogTitle(row.MALZEME_STOK_NO + '-' + row.MALZEME);
    setDeleteId(row.ID);
    setOpen(true);
  };

  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoading(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + ' Numaralı Malzeme Detayı');
    axios
      .get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrlMuadil(fileURL);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };

  return (
    <Card>
      <CardHeader
        title="İşlemler"
        action={
          <Grid container spacing={3}>
            <Grid item xs={6} sm={6}>
              <Button
                variant="contained"
                className={classes.button}
                color="secondary"
                endIcon={<BallotIcon></BallotIcon>}
                onClick={event => TumuSec(event)}
              >
                {SecKontrolYazi}
              </Button>
            </Grid>
            <Grid item xs={6} sm={6}>
              <Button
                variant="contained"
                className={classes.button}
                color="secondary"
                endIcon={<SendIcon></SendIcon>}
                onClick={event => SipariVer(event)}
                disabled={buttonDisabled}
              >
                SİparİşVer
              </Button>
            </Grid>
          </Grid>
        }
      />
      <Divider />
      <Snackbar
        open={uyari}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={uyariKapat}
      >
        <Alert onClose={uyariKapat} severity={uyariTip}>
          {uyariAciklama || ''}
        </Alert>
      </Snackbar>
      <CardContent>
        <TableContainer className={classes.container}>
          <Table className={classes.table} size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="left">Seçim</TableCell>
                <TableCell align="left">SipVerilebilir</TableCell>
                <TableCell align="left">Onay Durumu</TableCell>
                <TableCell align="left">Resim</TableCell>
                <TableCell align="left">MalzemeStokNo</TableCell>
                <TableCell align="left">Malzeme</TableCell>
                <TableCell align="center">DepoAdet</TableCell>
                <TableCell align="right">Fiyat</TableCell>
                <TableCell align="center">Adet</TableCell>
                <TableCell align="center">TalepEden</TableCell>
                <TableCell align="center">Sil</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {SiparisData.sort(
                ({ isEditMode: previousID }, { isEditMode: currentID }) =>
                  previousID - currentID
              )
                // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(index);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isItemSelected}
                      className={
                        (limiteTakilanlar.includes(row.MALZEME_STOK_NO) &&
                          row.ONAY_DURUMU !== 'Beklemede' &&
                          row.ONAY_DURUMU !== 'Onaylandi' &&
                          row.ONAY_DURUMU !== 'SAP Depo Kontrolü Bekleniyor') ||
                        row.ONAY_DURUMU === 'Reddedildi'
                          ? classes.highlightRow
                          : ''
                      }
                    >
                      <TableCell padding="checkbox">
                        {row.SIP_VERILEBILIR === 1 &&
                        row.ONAY_DURUMU !== 'Reddedildi' &&
                        row.ONAY_DURUMU !== 'Beklemede' &&
                        row.ONAY_DURUMU !== 'SAP Depo Kontrolü Bekleniyor' ? (
                          <Checkbox
                            onClick={event => handleClick(event, row, index)}
                            checked={row.RowSelected}
                            color="primary"
                            inputProps={{ 'aria-labelledby': labelId }}
                          />
                        ) : (
                          ''
                        )}
                      </TableCell>
                      <TableCell align="center" className={classes.tableCell}>
                        {row.SIP_VERILEBILIR === 0 ? (
                          <LockIcon color="error" />
                        ) : (
                          <DoneIcon color="success" />
                        )}
                      </TableCell>
                      <TableCell align="center" className={classes.tableCell}>
                        {row.ONAY_DURUMU}
                      </TableCell>
                      <TableCell
                        padding="none"
                        align="center"
                        className={classes.tableCell}
                      >
                        <ImageSearchIcon
                          onClick={event =>
                            GetMaterialImage(
                              event,
                              row.MALZEME_STOK_NO.replace(/^0+/, '')
                            )
                          }
                          color="primary"
                        />
                      </TableCell>
                      <TableCell align="left" className={classes.tableCell}>
                        {row.MALZEME_STOK_NO}
                      </TableCell>
                      <TableCell
                        align="left"
                        title={row.MALZEME}
                        className={classes.tableCell}
                      >
                        {row.MALZEME.substring(0, 20)}...
                      </TableCell>
                      <TableCell
                        align="left"
                        title={row.DEPO_ADET}
                        className={classes.tableCell}
                      >
                        {row.DEPO_ADET}
                      </TableCell>
                      <TableCell
                        align="right"
                        title={row.MALZEME}
                        className={classes.tableCell}
                      >
                        {row.BIRIM_FIYAT.toFixed(2)} ₺
                      </TableCell>
                      <CustomTableCell
                        {...{
                          row,
                          name: 'Count',
                          onChange,
                          Adet: row.Count,
                          onayDurumu:
                            row.ONAY_DURUMU == 'Beklemede' ||
                            row.ONAY_DURUMU == 'Onaylandi' ||
                            row.ONAY_DURUMU == 'Reddedildi' ||
                            row.ONAY_DURUMU == 'SAP Depo Kontrolü Bekleniyor'
                        }}
                      />
                      <TableCell align="left" className={classes.tableCell}>
                        {row.KULLANICI}
                      </TableCell>
                      <TableCell
                        align="left"
                        title={row.MALZEME}
                        className={classes.tableCell}
                      >
                        {row.ONAY_DURUMU !== 'Beklemede' &&
                        row.ONAY_DURUMU !== 'SAP Depo Kontrolü Bekleniyor' ? (
                          <DeleteForeverIcon
                            onClick={() => SetMalzemeSiparisCikar(row)}
                            color="error"
                          />
                        ) : (
                          ''
                        )}
                      </TableCell>
                      <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <DialogTitle id="alert-dialog-title">
                          {dialogTitle}
                        </DialogTitle>
                        <DialogContent>
                          <DialogContentText id="alert-dialog-description">
                            Malzeme sipariş listesinden çıkartılacaktır!...
                            Devam etmek istediğinizden emin misiniz?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button onClick={handleClose} color="primary">
                            HAYIR
                          </Button>
                          <Button
                            onClick={() =>
                              SetMalzemeSiparisCikarKabul(row, DeleteId)
                            }
                            color="primary"
                            autoFocus
                          >
                            EVET
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </TableRow>
                  );
                })}
              <TableRow>
                <TableCell colSpan="4" align="right">
                  <b>Toplam : </b>
                </TableCell>
                <TableCell align="right">
                  <b>{invoiceTotal.toFixed(2)} ₺</b>
                </TableCell>
                <TableCell align="center">
                  <b>{CountTotal}</b>
                </TableCell>
                <TableCell align="left"></TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan="7" align="center">
                  <Typography variant="h6" component="p">
                    {parseInt(invoiceTotal) > 10000 ? (
                      <Alert severity="warning">
                        Toplam sipariş tutarınız 10.000 TL yi geçmiş
                        bulunmaktadır.
                      </Alert>
                    ) : (
                      ''
                    )}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth="lg"
        onClose={handleCloseMaterialFile}
      >
        <DialogTitle>{openMaterialFileTitle}</DialogTitle>
        <DialogContent>
          {Loading ? (
            <LinearProgress status="loading" />
          ) : (
            <img style={{ width: '100%' }} alt="" src={ImageUrlMuadil} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openApproveDialog}
        maxWidth={'lg'}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseApproveDialog}
      >
        <DialogTitle>Onaya Gönderme Sebebi</DialogTitle>
        <DialogContent>
          <Input
            fullWidth
            className={classes.input}
            onChange={handleInputChange}
            value={approveReason}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseApproveDialog} color="primary">
            Gönder
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openOrderTypeDialog}
        maxWidth={'md'}
        TransitionComponent={Transition}
        keepMounted
        onClose={setOpenOrderTypeDialog}
      >
        <DialogTitle id="alert-dialog-title">
          {'Son 3 aylık sarfının üstünde malzeme talep ediyorsun, emin misin?'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <FormControl>
                <RadioGroup
                  aria-labelledby="orderType-group-label"
                  name="radio-buttons-group"
                  value={orderType}
                  onClick={handleOrderTypeChange}
                >
                  <FormControlLabel
                    value="ST"
                    control={<Radio />}
                    label="Evet"
                  />
                  <FormControlLabel
                    value="YS"
                    control={<Radio />}
                    label="Hayır"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            {orderType === 'ST' && (
              <Grid item xs={12} sx={{ width: '100%' }}>
                <Box sx={{ width: '100%' }}>
                  <TextField
                    id="outlined-multiline-static"
                    label="Sipariş Sebebi"
                    fullWidth
                    multiline
                    rows={3}
                    defaultValue={orderReason}
                    onBlur={handleOrderReason}
                  />
                </Box>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              if (!orderReason.trim() && orderType == 'ST') {
                setUyariAciklama('Sipariş sebebi giriniz!');
                setUyari(true);
              } else {
                setOpenOrderTypeDialog(false);
                SipariVer();
              }
            }}
            color="primary"
          >
            ONAYLA
          </Button>
          <Button
            onClick={() => {
              setOpenOrderTypeDialog(false);
              setOrderType('');
            }}
            color="primary"
          >
            KAPAT
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}

export default MaterialOrder;
